import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dayPill", "prevLink", "nextLink"]
  static values = { weekStart: String, autoOpenDate: String, autoOpenMeal: String }

  connect() {
    // Server-driven auto-open: when the user lands on /meal-plan with
    // ?for=tonight (or another date hint set in the controller), the
    // picker opens immediately for that day so they don't have to tap
    // a second time. Used by the dashboard "Pick a recipe" CTA when
    // tonight has no plan.
    if (this.hasAutoOpenDateValue && this.autoOpenDateValue) {
      const meal = this.hasAutoOpenMealValue && this.autoOpenMealValue ? this.autoOpenMealValue : "dinner"
      requestAnimationFrame(() => {
        this.openPicker({ params: { mealType: meal, date: this.autoOpenDateValue } })
      })
    }
  }

  openPicker(event) {
    const mealType = event.params.mealType
    const date = event.params.date
    const sheet = document.getElementById("meal-plan-picker")
    if (!sheet) return

    // Drive the lazy Turbo Frame: set its src so the picker fetches with the
    // right date+meal_type baked into the response. Hidden fields in the
    // picker rows render with these values pre-populated, so we don't need
    // to mutate them client-side after load.
    const frame = sheet.querySelector("turbo-frame#meal-plan-recipe-picker")
    if (frame) {
      const baseSrc = frame.dataset.basePath || "/meal-plan/recipe_picker"
      const params = new URLSearchParams({ date, meal_type: mealType })
      const nextSrc = `${baseSrc}?${params.toString()}`
      if (frame.src !== nextSrc) {
        frame.src = nextSrc
      }
    }

    // Belt-and-suspenders: if the frame has already loaded with stale fields,
    // sync the values now too (matches the legacy behavior; cheap when
    // there's nothing to mutate).
    sheet
      .querySelectorAll("[data-recipe-picker-target='dateField']")
      .forEach((field) => (field.value = date))
    sheet
      .querySelectorAll("[data-recipe-picker-target='mealTypeField']")
      .forEach((field) => (field.value = mealType))

    const modal = this.application.getControllerForElementAndIdentifier(sheet, "modal")
    if (modal) modal.open()
  }

  showSlot(event) {
    event.preventDefault()
    const slot = event.params.slot

    this.openPicker({
      params: { mealType: slot, date: this.weekStartValue },
    })
  }
}
